import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Engine from "./pages/Engine";
import EngineEmbed from "./pages/EngineEmbed";
import ReviewsEmbed from "./pages/ReviewsEmbed";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import DataDeletion from "./pages/DataDeletion";
import Cards from "./pages/Cards";
import Faq from "./pages/Faq";
import BlogIndex from "./pages/BlogIndex";
import BlogPost from "./pages/BlogPost";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/engine" element={<Engine />} />
                    <Route path="/engine/embed" element={<EngineEmbed />} />
                    <Route path="/embed/reviews" element={<ReviewsEmbed />} />
                    <Route
                        path="/privacy-policy"
                        element={<PrivacyPolicy />}
                    />
                    <Route
                        path="/terms-of-service"
                        element={<TermsOfService />}
                    />
                    <Route path="/data-deletion" element={<DataDeletion />} />
                    <Route path="/cards" element={<Cards />} />
                    <Route path="/faq" element={<Faq />} />
                    <Route path="/blog" element={<BlogIndex />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
